import { createFileRoute } from "@tanstack/react-router";
import TermsOfService from "@/pages/TermsOfService";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/terms")({
  head: () => pageHead("terms", "en"),
  component: TermsOfService,
});
